import {Box, Typography} from '@mui/material';
import styles from './style.module.scss';
import React from 'react';
type AurAskLioFeedbackToastProps = {
  title: string;
  visible: boolean;
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
  className?: string;
  timeout?: number;
};

const AurAskLioFeedbackToast: React.FC<AurAskLioFeedbackToastProps> = ({
  title,
  Icon,
  visible,
  className,
}) => {
  return (
    <>
      <Box
        aria-label={title}
        className={`${className} ${styles.aurAskLioFeedbackToast} ${styles.aurSlideUp} ${visible ? styles.displayFlex : styles.displayNone}`}
      >
        <span>
          <Icon aria-hidden="true" />
        </span>
        <Typography>{title}</Typography>
      </Box>
    </>
  );
};

export default AurAskLioFeedbackToast;
